import { Sites } from '@ps/platform-message-framework/common/Sites';
import React, { useState } from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import { Country } from '@swf/core/enums';
import { select } from '@swf/core/store';

import CTAButton from '../../../../../CTAButton/CTAButton';

import { ctaButton, signupCountrySelect } from './SignupCountrySelect.scss';
import SignupCountryField from './components/SignupCountryField';

const SignupCountrySelect: React.FC = () => {
  const form = useForm();
  const site = useSelector(select.cms.getSiteId);
  const [country, setCountry] = useState<{ value: string; text: string }>();
  const [region, setRegion] = useState<{ value: string; text: string }>();

  const handleCountrySelect = (newCountry: { value: string; text: string }) => {
    setCountry(newCountry);
  };

  const handleRegionSelect = (newCountry: { value: string; text: string } | undefined) => {
    setRegion(newCountry);
  };

  const handleSubmit = (e: React.MouseEvent) => {
    e.preventDefault();
    const isAvailableCountryForRegion =
      (country?.value === Country.Canada && (site === Sites.COM || site === Sites.CA_ON)) ||
      (country?.value === Country.Argentina && site === Sites.SPA);
    if (isAvailableCountryForRegion && !region) return;
    form.submit();
  };

  return (
    <>
      <div className={country && signupCountrySelect}>
        <SignupCountryField
          showBorders={false}
          onCountryChange={handleCountrySelect}
          onRegionChange={handleRegionSelect}
          submitOnSelectionChange
        />
      </div>
      {country && <CTAButton className={ctaButton} onClick={handleSubmit} />}
    </>
  );
};

export default SignupCountrySelect;
